// apiClient.js
//const BASE_URL = "http://api-resistencia.inmegen.gob.mx/";
//const BASE_URL =  "http://localhost:4000/";

const BASE_URL = process.env.REACT_APP_ATLAS_API_RUTE;

function buildUrl(path, params) {
    const url = new URL(path.startsWith("http") ? path : `${BASE_URL}${path}`);
    if (params) {
        Object.entries(params).forEach(([k, v]) => {
            if (v === undefined || v === null) return;
            url.searchParams.set(k, String(v));
        });
    }
    return url.toString();
}

export async function apiRequest(path, options = {}) {
    const {
        method = "GET",
        params,
        body,
        headers,
        signal,
        token, // opcional: si usas Bearer
    } = options;

    const url = buildUrl(path, params);

    const res = await fetch(url, {
        method,
        signal,
        headers: {
            Accept: "application/json",
            ...(body ? { "Content-Type": "application/json" } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...headers,
        },
        body: body ? JSON.stringify(body) : undefined,
    });

    // Parseo JSON “seguro” (hay APIs que responden 204 o body vacío)
    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        // Si el backend NO manda JSON aunque dijo que sí:
        data = { raw: text };
    }

    if (!res.ok) {
        const message =
            (data && (data.message || data.error)) ||
            `HTTP ${res.status} ${res.statusText}`;
        const err = new Error(message);
        err.status = res.status;
        err.data = data;
        throw err;
    }

    return data;
}


export async function uploadFileByChunks(file) {
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);

    for (let index = 0; index < totalChunks; index++) {

        const start = index * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("chunk", chunk);
        formData.append("chunkIndex", index);
        formData.append("totalChunks", totalChunks);
        formData.append("filename", file.name);

        const response = await fetch("http://api-resistencia.inmegen.gob.mx/upload_chunk.php", {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error("Error subiendo chunk " + index);
        }
    }

}

